import React, { useCallback } from 'react';
import ServiceCom from '../KlarityServices';
import { EProviderType, ProviderLicenseFromDataWithoutState, ServiceExt, UniprofileFormData } from 'types/provider';
import { PracitceAddressForm } from 'types/practiceFront';
import { NoticeType } from 'antd/es/message/interface';
import useGetProviderAllInsurance from 'hooks/useGetProviderAllInsurance';
import { Spin } from 'antd';

interface IProps {
    licenses?: ProviderLicenseFromDataWithoutState;
    addressList?: Array<PracitceAddressForm>;
    isOps?: boolean;
    // 运营端需要传当前操作的用户id
    providerId?: number;
    // showTypeCheckbox?: boolean;
    showEditButtons?: boolean;
    initFormValue: Array<ServiceExt>;
    refetch: () => void;
    // onSubmit: (data: ISubmitChannelRelationshipData, ste: StepValue) => void;
    onShowMessage: (type: NoticeType, content: string) => void;
    setDisallowNext?: (disallow: boolean) => void;
    setDisallowNextTips?: (tips: string) => void;
    isReviewStep?: boolean;
    showSyncButton?: boolean;
    onClickSync?: () => void;
    checkTargetSpecialty?: boolean;
    provider?: UniprofileFormData;
}

const Services = (props: IProps) => {
    const { addressList, isOps, providerId, showEditButtons, initFormValue, refetch, onShowMessage, licenses, setDisallowNext, setDisallowNextTips, isReviewStep, showSyncButton, onClickSync, checkTargetSpecialty, provider } = props;

    const [uniprofileInsuranceData, loading] = useGetProviderAllInsurance(providerId, isOps);

    return (
        <Spin spinning={loading}>
            <ServiceCom
                provider={provider}
                providerType={EProviderType.KIWI}
                isReviewStep={isReviewStep}
                showSyncButton={showSyncButton}
                onClickSync={onClickSync}
                isOps={isOps}
                providerId={providerId}
                checkTargetSpecialty={checkTargetSpecialty}
                addressList={addressList}
                licenses={licenses}
                onShowMessage={onShowMessage}
                refetch={refetch}
                setDisallowNext={setDisallowNext}
                setDisallowNextTips={setDisallowNextTips}
                uniprofileInsuranceData={uniprofileInsuranceData}
            />
        </Spin>
    );
};

export default Services;
